import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function YoutubeVideoCardWPAEnterprise() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="MVvFninBFzE"
                    title="Überwachungskameras mit WPA2/3 Enterprise (EAP): Neue Maßstäbe in Sachen WLAN Sicherheit bei INSTAR"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="WLAN WPA2/3 Enterprise (EAP)"
              footer={
                <EuiText>
                  <p>Überwachungskameras mit WPA2/3 Enterprise (EAP): Neue Maßstäbe in Sachen WLAN Sicherheit bei INSTAR</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}
